import { LitElement, css, html, nothing } from "lit";
import { customElement, property } from "lit/decorators.js";
import { requestEvents } from "@/lib/requests";

@customElement("c-probac-info-for-user")
export class ProbacInfoWidget extends LitElement {
    static styles = css`
        :host {
        }

        div {
            display: flex;
            justify-content: center;
        }

        c-table {
            display: block;
            width: 500px;
        }
    `;

    @property({ attribute: "data-data", type: Object })
    user: {
        identity: string;
    };

    handleEvent(event: CustomEvent) {
        const table = this.renderRoot.querySelector("c-table");
        if (table) {
            table.refresh();
        }
    }

    async connectedCallback() {
        super.connectedCallback();

        requestEvents.get("/user").addEventListener("created", this);
        requestEvents.get("/user/{user_id}").addEventListener("updated", this);
        requestEvents.get("/user/{user_id}").addEventListener("deleted", this);
        requestEvents
            .get("/user/{user_id}/make-user")
            .addEventListener("created", this);
        requestEvents
            .get("/user/{user_id}/make-user-manager")
            .addEventListener("created", this);
    }

    async disconnectedCallback() {
        super.disconnectedCallback();

        requestEvents.get("/user").removeEventListener("created", this);
        requestEvents
            .get("/user/{user_id}")
            .removeEventListener("updated", this);
        requestEvents
            .get("/user/{user_id}")
            .removeEventListener("deleted", this);
        requestEvents
            .get("/user/{user_id}/make-user")
            .removeEventListener("created", this);
        requestEvents
            .get("/user/{user_id}/make-user-manager")
            .removeEventListener("created", this);
    }

    render() {
        if (!this.user) {
            return nothing;
        }

        return html`<div>
            <c-table
                data-service-repository="userDomainRoles"
                data-service-repository-parameters=${JSON.stringify({
                    user_id: this.user.identity,
                })}
                data-columns='[{"field":"domain_name","header":"Domain"}, {"field":"role_name","header":"Role"}, {"field":"authorized","header":"Authorized"}]'
                data-avoid-toast-on-submit
                data-avoid-search
                data-compact
            >
            </c-table>
        </div>`;
    }
}
